import { render, staticRenderFns } from "./CustomizationView.vue?vue&type=template&id=02d9c7dc&scoped=true"
import script from "./CustomizationView.vue?vue&type=script&lang=js"
export * from "./CustomizationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d9c7dc",
  null
  
)

export default component.exports